module.exports = {"420606001":"汉江街道","420606002":"王寨街道","420606003":"中原街道","420606004":"定中门街道","420606005":"清河口街道","420606006":"屏襄门街道","420606007":"米公街道","420606008":"柿铺街道","420606070":"高新区紫贞街道","420606071":"高新区七里河街道","420606072":"高新区东风街道","420606100":"牛首镇","420606101":"太平店镇","420606170":"高新区团山镇","420606171":"高新区米庄镇","420606400":"经济开发区","420606480":"鱼梁洲开发区","420606570":"高新区汽车工业园","420606571":"高新区高新技术产业园","420606572":"高新区高新技术创业服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420606.json
// module id = 1862
// module chunks = 0